import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Config } from "../config";
import { environment } from "../../../environments/environment";
import { LoginModel2 } from "../../pages/login/model/loginRequest";
import { CreatClient } from "../../pages/login/model/createClient";
import {
  ResetPassword,
  updateAdminUser,
} from "../../pages/login/model/resetPassword";
import { PassReset } from "../../pages/login/model/passReset";
import { catchError } from "rxjs/operators";
import { DataStore } from "../../shared/data-store.service";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";
import "rxjs/add/observable/throw";

@Injectable()
export class AuthServiceService {
  constructor(
    public http: HttpClient,
    private _conf: Config,
    private dataservice: DataStore
  ) {}
  url: string = environment.ghBaseUrl;
  // url = this._conf.url;
  _body = this._conf.body;

  //  btoa('Authorisation','Basic ' + )

  accessControl() {
    this._body.duration = "3900";
    return this.http.post(
      this._conf.accessControlUrl + this._conf.accessControl,
      JSON.stringify(this._body)
    );
  }

  getUserAuth(clientID: string, clientName: string) {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("X_CLIENT_ID", clientID);
    return this.http.get(
      `${this.url}${this._conf.userAuthToken}${clientID}/token?email=${clientName}`,
      { headers: httpHeaders }
    );
  }

  login(clientID: LoginModel2): Observable<any> {
    let headers = new HttpHeaders({
      x_client_id: clientID.clientId,
    });

    return this.http
      .post(this.url + this._conf.loginv2, JSON.stringify(clientID), {
        headers,
      })
      .pipe(
        catchError((err) => {
          return Observable.throw(err);
        })
      );
  }

  // login version one before the client removal update
  // login(clientID: LoginModel) {
  //   let httpHeaders = new HttpHeaders();
  //   httpHeaders = httpHeaders.append("X_CLIENT_ID", clientID.clientId);
  //   return this.http.post(
  //     this.url + this._conf.login,
  //     JSON.stringify(clientID),
  //     { headers: httpHeaders }
  //   );
  // }

  register(newClient: CreatClient) {
    newClient.notificationSender = environment.notificationSender;
    newClient.activationLink = environment.activationLink;
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("X_CLIENT_ID", newClient.clientId);
    return this.http.post(
      this.url + this._conf.createClient,
      JSON.stringify(newClient),
      { headers: httpHeaders }
    );
  }

  recoverPassword(newClient: ResetPassword) {
    let httpHeaders = new HttpHeaders();
    // httpHeaders = httpHeaders.append("X_CLIENT_ID", newClient.clientId);
    return this.http.post(
      this.url + this._conf.recoverPassword,
      JSON.stringify(newClient)
      // { headers: httpHeaders }
    );
  }

  resetPassword(newPass: PassReset) {
    // let httpHeaders = new HttpHeaders();
    // httpHeaders = httpHeaders.append("X_CLIENT_ID", newPass.clientId);
    return this.http.post(
      this.url + this._conf.resetpassword,
      JSON.stringify(newPass)
      // { headers: httpHeaders }
    );
  }

  // this update is called on client signup.  which auto register the client user email for notice.
  // where the user name is the client email
  //using the forgot passwor dpayload instead of the actual update user payload. that is all that is required in this instance
  updateClientUser(newClient: updateAdminUser) {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("X_CLIENT_ID", newClient.clientId);
    return this.http.post(
      `${this.url}${this._conf.updateAdminClientUser}`,
      JSON.stringify(newClient),
      { headers: httpHeaders }
    );
  }
}
